<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps({
  markers: { type: Array, default: () => [] },
  center: { type: Object, default: () => ({ lat: -23.55052, lng: -46.633308 }) },
  zoom: { type: Number, default: 13 },
  enableDraw: { type: Boolean, default: true },
});

const emit = defineEmits(['polygon-changed', 'marker-click', 'map-ready']);

const mapEl = ref(null);
const fullscreen = ref(false);

const ensureLeaflet = () =>
  new Promise(resolve => {
    if (window.L) {
      resolve(window.L);
      return;
    }
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(css);
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.onload = () => resolve(window.L);
    document.head.appendChild(script);
  });

onMounted(async () => {
  const L = await ensureLeaflet();
  const map = L.map(mapEl.value).setView([props.center.lat, props.center.lng], props.zoom);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '© OpenStreetMap' }).addTo(map);
  props.markers.forEach(m => {
    const marker = L.marker([m.lat, m.lng]).addTo(map);
    marker.on('click', () => emit('marker-click', m));
  });

  if (props.enableDraw) {
    let polygon = null;
    const points = [];
    map.on('click', event => {
      points.push(event.latlng);
      if (polygon) map.removeLayer(polygon);
      polygon = L.polygon(points, { color: '#49317a', fillOpacity: 0.15 }).addTo(map);
      emit('polygon-changed', points.map(p => ({ lat: p.lat, lng: p.lng })));
    });
    map.on('dblclick', () => {
      points.length = 0;
      if (polygon) map.removeLayer(polygon);
      emit('polygon-changed', []);
    });
  }

  emit('map-ready', map);
});
</script>

<template>
  <div class="relative" :class="fullscreen ? 'fixed inset-0 z-40 bg-white p-2' : ''">
    <div ref="mapEl" class="h-[420px] w-full overflow-hidden rounded-lais" />
    <button
      type="button"
      class="absolute right-2 top-2 rounded-full bg-white px-3 py-1 text-[12px] font-semibold shadow-lais-card"
      @click="fullscreen = !fullscreen"
    >
      {{ fullscreen ? 'Sair da tela cheia' : 'Tela cheia' }}
    </button>
  </div>
</template>
